import {
  AutoComplete,
  AutoCompleteCompleteEvent,
} from "primereact/autocomplete";
import { LabelValue } from "@shared/models/label-value.interface";
import { useCallback, useEffect, useState } from "react";
import { GetResponsePersonModel } from "@factory/model/query-model-person";
import { useQyGetPerson } from "@factory/query/person.query";

export function useAutocompletePerson(
  defaultValue: LabelValue | null,
  name: string,
  label: string,
  hint: string,
  isDoctor: boolean,
  onAutocompleteSelect: (selectedPerson: any | null) => void
) {
  const [value, setValue] = useState(defaultValue);
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState<LabelValue[]>([]);
  const [enabledGet, setEnabledGet] = useState(false);

  // QUERY
  const handleSuggestions = (response: GetResponsePersonModel) => {
    const mappedSuggestions = (response?.data || [])
      .map(
        (item) =>
          ({
            label: `${item.last_name} ${item.first_name}`,
            value: item.code,
          } as LabelValue)
      )
      .filter((x) => !!x.label);

    setSuggestions(mappedSuggestions);
  };
  useQyGetPerson(
    searchTerm,
    999999,
    0,
    undefined,
    { role_name: "Doctor" },
    enabledGet,
    handleSuggestions
  );

  // LOCAL
  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);
  
  const onSearch = useCallback(
    (term: AutoCompleteCompleteEvent) => {
      setSearchTerm(term.query);
      setEnabledGet(true);
    },
    [setSearchTerm, setEnabledGet]
  );
  const handleSelect = useCallback(
    (selected: LabelValue) => {
      setValue(selected);
      onAutocompleteSelect(selected);
    },
    [setValue, onAutocompleteSelect]
  );

  // HTML
  const formElement = (
    <div
      id="AutocompletePerson"
      className="autocomplete-person person field mt-5"
    >
      <span className="p-float-label">
        <AutoComplete
          id={name}
          field="label"
          inputClassName="w-full"
          className="w-full"
          placeholder="Type to find a person"
          value={value}
          suggestions={suggestions}
          onChange={(e) => {
            handleSelect(e.value);
          }}
          completeMethod={onSearch}
          forceSelection={true}
        />
        <label className="text-xs text-gray-500" htmlFor={name}>
          {label}
        </label>
      </span>
      <small className="text-gray-400 mb-1">{hint}</small>
    </div>
  );

  return {
    formElement,
  };
}

export default useAutocompletePerson;
